import { Upload, FileCheck, Loader } from 'lucide-react';
import { AnalysisNameEditor } from './AnalysisNameEditor';
import { MAX_URLS } from '../../utils/constants';

export const UploadArea = ({
    file,
    isAnalyzing,
    isDragging,
    estimatedTime,
    isEditing,
    analysisName,
    tempName,
    startEditing,
    saveEdit,
    cancelEdit,
    handleKeyPress,
    setTempName,
    inputRef,
    handleFileUpload,
    handleDragOver,
    handleDragLeave,
    handleDrop,
}) => (
    <div
        className={`flex-1 border-2 border-dashed rounded-lg p-4 min-h-32 transition-all duration-200 ease-in-out
            ${isAnalyzing ? 'bg-gray-50' :
                file ? 'border-green-500 bg-green-50' :
                    isDragging ? 'border-blue-400 bg-blue-50 scale-102 shadow-lg' :
                        'hover:bg-accent'}`}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
    >
        <label className={`flex flex-col items-center justify-center h-full ${isAnalyzing ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
            <div className="flex flex-col items-center justify-center space-y-1.5">
                {isAnalyzing ? (
                    <>
                        <div className="animate-spin">
                            <Loader className="h-10 w-10 text-blue-400" />
                        </div>
                        <div className="flex flex-col items-center space-y-1">
                            <p className="text-sm font-medium text-blue-400">
                                Analyzing
                            </p>
                            {estimatedTime && (
                                <p className="text-xs text-blue-400/80 text-center">
                                    Estimated time: ~{estimatedTime} <br/> You can close the page or start a new analysis, we'll email you the results.
                                </p>
                            )}
                        </div>
                    </>
                ) : file ? (
                    <>
                        <FileCheck className="h-10 w-10 text-green-500" />
                        <div className="flex flex-col items-center space-y-1.5">
                            <p className="text-sm font-medium text-green-600">
                                Ready for analysis
                            </p>
                            <div className="relative flex items-center justify-center">
                                <AnalysisNameEditor
                                    isEditing={isEditing}
                                    analysisName={analysisName}
                                    tempName={tempName}
                                    startEditing={startEditing}
                                    saveEdit={saveEdit}
                                    cancelEdit={cancelEdit}
                                    handleKeyPress={handleKeyPress}
                                    setTempName={setTempName}
                                    inputRef={inputRef}
                                />
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <Upload className={`h-10 w-10 transition-transform duration-200 ${isDragging ? 'scale-110 text-blue-400' : 'text-muted-foreground'}`} />
                        <div className="flex flex-col items-center space-y-2">
                            <p className="text-sm text-center font-medium text-muted-foreground">
                                {isDragging ? 'Drop to upload' : 'Click to upload or drag and drop'}
                            </p>
                            <p className="text-xs text-center text-muted-foreground">
                                CSV file with website URLs (max. {MAX_URLS.toLocaleString()} URLs).
                            </p>
                        </div>
                    </>
                )}
            </div>
            <input
                type="file"
                className="hidden"
                accept=".csv,text/csv,application/vnd.ms-excel,application/csv,text/x-csv,application/x-csv"
                onChange={handleFileUpload}
                disabled={isAnalyzing}
            />
        </label>
    </div>
);